module.exports = __webpack_public_path__ + "static/attraction-7adada0c718556a1593bd8bb91f4573f.jpeg";